import { Heart, BookOpen } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-100 bg-white/60 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-2xl bg-gradient-to-br from-sky-400 to-sky-500 flex items-center justify-center">
            <BookOpen className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display text-xl font-semibold text-slate-900">
            Phon<span className="text-sky-500">X</span>
          </span>
        </div>
        <p className="text-sm text-slate-500 text-center flex items-center gap-1.5">
          Built with <Heart className="w-4 h-4 text-rose-500" fill="currentColor" /> to make reading fun for everyone.
        </p>
        <p
          data-testid="footer-credit"
          className="text-xs font-bold text-slate-600"
        >
          Chris Roach and AI · <span className="text-sky-500">Tech10</span>
        </p>
        <p className="text-xs text-slate-400">© {new Date().getFullYear()} PhonX. All rights reserved.</p>
      </div>
    </footer>
  );
}
